<template>
  <div class="google-management">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'GoogleManagement'
  }
</script>

<style scoped>
  .google-management {
    width: 100%;
    height: 100%;
  }
</style>
